__webpack_require__.p = "/top-navbar-refresh/referrals/";